import { useImperativeHandle, useRef } from 'react';
import { OpenableOverlay } from '../OpenableOverlay';
import { BaseMonthPicker } from './BaseMonthPicker';

const OverlayedMonthPicker = ({ anchorElement, opened, onKeyDown, impRef, ...other }: $TSFixMe) => {
    const overlayElementRef = useRef(null);
    const calendarComponentRef = useRef(null);

    const overlayProps = {
        anchorElement,
        opened,
        onKeyDown,
        innerRef: overlayElementRef,
    };

    const calendarProps = {
        ...other,
        impRef: calendarComponentRef,
    };

    const getOverlayEl = () => overlayElementRef.current;
    const getCalendarEl = () => calendarComponentRef.current;

    useImperativeHandle(impRef, () => ({
        getOverlayEl,
        getCalendarEl,
    }));

    return (
        <OpenableOverlay {...overlayProps}>
            <BaseMonthPicker {...calendarProps} />
        </OpenableOverlay>
    );
};

export default OverlayedMonthPicker;
